import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import Button from './Button';

const SendDateModal = ({ isOpen, onClose, onImmediate, onConfirm, children }) => {
  const { t } = useTranslation();
  const modalRef = useRef(null);
  const previousFocusRef = useRef(null);

  useEffect(() => {
    if (!isOpen) return;

    previousFocusRef.current = document.activeElement;
    document.body.style.overflow = 'hidden';

    const handleKeyDown = (e) => {
      if (e.key === 'Escape') {
        onClose();
        return;
      }
      if (e.key === 'Tab' && modalRef.current) {
        const focusables = modalRef.current.querySelectorAll(
          'button:not([disabled]), [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
        );
        if (focusables.length === 0) return;
        const first = focusables[0];
        const last = focusables[focusables.length - 1];
        if (!e.shiftKey && document.activeElement === last) {
          e.preventDefault();
          first.focus();
        } else if (e.shiftKey && document.activeElement === first) {
          e.preventDefault();
          last.focus();
        }
      }
    };

    document.addEventListener('keydown', handleKeyDown);
    modalRef.current?.focus();

    return () => {
      document.removeEventListener('keydown', handleKeyDown);
      document.body.style.overflow = 'auto';
      if (previousFocusRef.current) previousFocusRef.current.focus();
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return (
    <div
      className="dateModalOverlay"
      onClick={(e) => {
        if (e.target === e.currentTarget) onClose();
      }}
    >
      <div
        className="dateModal"
        role="dialog"
        aria-modal="true"
        aria-label={t("Date d'envoi")}
        ref={modalRef}
        tabIndex="-1"
      >
        <div className="dateModalHead">
          <button
            type="button"
            className="dateModalClose"
            onClick={onClose}
            aria-label={t('Fermer')}
          >
            &times;
          </button>
        </div>

        <div className="dateModalBody">{children}</div>

        <button type="button" className="dateModalImmediate" onClick={onImmediate}>
          {t('Envoi immédiat')}
        </button>

        <Button className="dateModalConfirm" onClick={onConfirm}>
          {t('Confirmer')}
        </Button>
      </div>
    </div>
  );
};

SendDateModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onImmediate: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  children: PropTypes.node
};

export default SendDateModal;
